import { Component } from '@angular/core';
import {
	MatterMortgageInstructionSource,
	MatterMortgageWithAssociations,
} from '@models/mortgage';
import { Select } from '@ngxs/store';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-mortgage',
	templateUrl: './mortgage.component.html',
	styleUrls: ['./mortgage.component.scss'],
	standalone: false,
})
export class MatterMortgageComponent {
	@Select(MatterMortgagesState.getSelectedMortgage)
	selectedMortgage$: Observable<MatterMortgageWithAssociations>;

	MATTER_MORTGAGE_INSTRUCTION_SOURCE = MatterMortgageInstructionSource;

	constructor() {}
}
